import axios from 'axios';
import { API_BASE_URL } from '../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';

export function useFetchSettingData(name: string) {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);

  const fetchData = () => {
    axios
      .get(`${API_BASE_URL}/settings?name=${name}`)
      .then((res) => {
        if (res.data.data.data.length === 0) {
          setIsFetching(false);
          return;
        }
        setData(res.data.data.data[0].value);
        setIsFetching(false);
      })
      .catch((err) => {
        setIsFetching(false);
      });
  };

  useEffect(() => {
    setIsFetching(true);
    fetchData();
  }, []);

  return {
    isFetching,
    data,
    fetchData,
  };
}
